import { COMPONENTS_LessonCom } from "../../assets/asset";
import inactiveFoundation from "../../assets/components/lessonDashboard/animals/foundation/inactive.webp";
import activeFoundation from "../../assets/components/lessonDashboard/animals/foundation/active.webp";
import inactiveYear1 from "../../assets/components/lessonDashboard/animals/year1/inactive.webp";
import activeYear1 from "../../assets/components/lessonDashboard/animals/year1/active.webp";
import inactiveYear2 from "../../assets/components/lessonDashboard/animals/year2/inactive.webp";
import activeYear2 from "../../assets/components/lessonDashboard/animals/year2/active.webp";
import inactiveYear3 from "../../assets/components/lessonDashboard/animals/year3/inactive.webp";
import activeYear3 from "../../assets/components/lessonDashboard/animals/year3/active.webp";
import inactiveYear4 from "../../assets/components/lessonDashboard/animals/year4/inactive.webp";
import activeYear4 from "../../assets/components/lessonDashboard/animals/year4/active.webp";
import inactiveYear5 from "../../assets/components/lessonDashboard/animals/year5/inactive.webp";
import activeYear5 from "../../assets/components/lessonDashboard/animals/year5/active.webp";
import inactiveYear6 from "../../assets/components/lessonDashboard/animals/year6/inactive.webp";
import activeYear6 from "../../assets/components/lessonDashboard/animals/year6/active.webp";

const LessonCom = ({
  yearId,
  onClick,
  isAttempt,
  lessonTopics,
  index,
  displayNumber,
}) => {
  const marginTop = index % 2 === 0 ? "mt-[70%]" : "mt-[100%]";

  function decideImage(yearId) {
    switch (yearId) {
      case 1:
        return {
          source: isAttempt !== "0" ? inactiveFoundation : activeFoundation,
          style: "-bottom-20 -left-3",
        };
      case 2:
        return {
          source: isAttempt !== "0" ? inactiveYear1 : activeYear1,
          style: "bottom-0 left-0 w-52",
        };
      case 3:
        return {
          source: isAttempt !== "0" ? inactiveYear2 : activeYear2,
          style: "",
        };
      case 4:
        return {
          source: isAttempt !== "0" ? inactiveYear3 : activeYear3,
          style: "-bottom-10 -left-8",
        };
      case 5:
        return {
          source: isAttempt !== "0" ? inactiveYear4 : activeYear4,
          style: "-bottom-2 -left-1 ",
        };
      case 6:
        return {
          source: isAttempt !== "0" ? inactiveYear5 : activeYear5,
          style: "-bottom-14 left-20",
        };
      case 7:
        return {
          source: isAttempt !== "0" ? inactiveYear6 : activeYear6,
          style: "bottom-0",
        };
    }
  }

  return (
    <div
      className={`flex flex-col w-80 h-80 ${
        isAttempt === "0" ? "p-4" : "pl-10 py-5"
      }  ${isAttempt} relative cursor-pointer ${marginTop}`}
      onClick={onClick}
      style={{
        backgroundImage: `url(${
          isAttempt === "0"
            ? COMPONENTS_LessonCom.lesson_card_bg
            : COMPONENTS_LessonCom.lesson_card__grey_bg
        })`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <img
        src={decideImage(yearId)?.source}
        style={{ transform: "scale(0.4)" }}
        className={`absolute h-auto ${decideImage(yearId)?.style} `}
        // removed scale-50
      />

      <div
        title={lessonTopics}
        className="flex w-[70%] mx-auto justify-between  flex-col h-[67%] items-center"
      >
        <ul className="flex-1 font-mali font-semibold text-sm text-dark-brown overflow-y-auto  my-2 list-none text-center">
          {lessonTopics}
        </ul>

        <div
          className={`w-20 h-20 border-4 ${
            isAttempt === "0" ? "border-custom-blue" : "border-custom-black"
          } rounded-full flex items-center justify-center text-center text-custom-text font-custom text-4xl ${
            isAttempt === "0" ? "text-custom-blue" : "text-custom-black"
          } ${isAttempt === "0" ? "bg-lesson-card-inner" : "bg-gray-400"}`}
        >
          {displayNumber}
        </div>
      </div>
    </div>
  );
};

export default LessonCom;
